import { Route, Routes, useLocation } from 'react-router-dom';
import './scss/style.scss';

import Header from './pages/Header';
import Main from './components/main/Main';
import Login from './pages/login';
import Proc from './components/proc/Proc';
import Hub from './components/proc/hub/Hub';
import Order from './components/proc/order/Order';
import Provide from './pages/provide';
import Cron from './pages/cron';
import Footer from './components/common/Footer';
import Market from './components/proc/market/Market';
function App() {
	const location = useLocation();
	return (
		<>
			<Header />
			<div className='layout'>
				<Routes>
					<Route path='/' element={<Main />} />
					<Route path='/login' element={<Login />} />
					<Route path='/proc' element={<Proc />} />
					<Route path='/hub' element={<Hub />} />
					<Route path='/order' element={<Order />} />
					<Route path='/provide' element={<Provide />} />
					<Route path='/market' element={<Market />} />
					<Route path='/cron' element={<Cron />} />
				</Routes>
			</div>
			{location.pathname === '/proc' && <Footer />}
		</>
	);
}

export default App;
